import { useState } from 'react';
import Icon from './Icon';
import AIAssistant from '../admin/AIAssistant';

export default function AIFloatingButton({ isAdmin, onOpenIntake }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating action button */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed right-4 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 shadow-lg shadow-indigo-500/30 flex items-center justify-center active:scale-90 transition-transform"
          style={{ bottom: '84px' }}
        >
          <Icon name="Sparkles" size={24} className="text-white" />
        </button>
      )}

      {/* Full-screen AI modal */}
      {open && (
        <div className="fixed inset-0 z-50 bg-t-bg flex flex-col safe-area-top safe-area-bottom animate-fadeIn">
          <AIAssistant isModal={true} onClose={() => setOpen(false)} onOpenIntake={() => { setOpen(false); onOpenIntake?.(); }} />
        </div>
      )}
    </>
  );
}
